import { createSlice } from "@reduxjs/toolkit";


import { AdminUserListProps } from "types/adminUserList";

const initialState: AdminUserListProps = {
  needToRefresh: false,
};


const adminuserlist = createSlice({
  name: "AdminUserList",
  initialState,
  reducers: {
    setNeedToRefresh(state, action) {
      state.needToRefresh = action.payload;
    },
  },
});

export default adminuserlist.reducer;

export const { setNeedToRefresh } = adminuserlist.actions;
